import AttendeesSessionsList from './AttendeesSessionsList';

export default AttendeesSessionsList;
